import $ from 'jquery';

import {
  HEADER_DISY_MESSAGES,
  MIMETYPE_DISY_VECTOR_LAYER_FEATURES
} from 'cadenza/api-client/api-constants';
import type { DimensionDto } from 'cadenza/api-client/dto/dimension-dto';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';
import { defaultXhrErrorHandler, fillUrlWithDefaultParams } from 'cadenza/api-client/api';

interface LayerFeaturesConfig {
  url: string;
  srsCode: string;
  mapSize: DimensionDto;
  extent: WorldBoxDto;
  featureAttributes: unknown[];
}

/* @see net/disy/cadenza/gis/web/layer/feature/rest/LayerFeatureEndpointController.java */
export function getLayerFeatures ({ url, srsCode, mapSize, extent, featureAttributes = [] }: LayerFeaturesConfig) {
  const ajaxOptions = {
    data: {
      bbox: extent.join(),
      srsCode,
      mapSize: String(mapSize),
      featureAttributes: featureAttributes.join()
    },
    headers: { Accept: MIMETYPE_DISY_VECTOR_LAYER_FEATURES }
  };

  url = fillUrlWithDefaultParams(url); // needed to provide params set up in ajaxSetup()
  return $.ajax(url, ajaxOptions)
    .then((result, textStatus, jqXhr) => {
      let messages = [];
      const messageHeader = jqXhr.getResponseHeader(HEADER_DISY_MESSAGES);
      if (messageHeader) {
        messages = JSON.parse(messageHeader);
      }
      return { result, messages };
    }, (jqXhr) => defaultXhrErrorHandler(jqXhr, e => { throw e; }) as Promise<never>);
}
